import SiteNavbar from './SiteNavbar.jsx'
import Footer from './Footer.jsx'

export default function BriefShell({ children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SiteNavbar theme="warm" />
      <main style={{ flex: 1, paddingTop: '60px' }}>{children}</main>
      <Footer text="Morning Brief · Private briefing app" />
    </div>
  )
}
